import { render } from "./ExamLearn.vue?vue&type=template&id=51090a25"
import script from "./ExamLearn.vue?vue&type=script&lang=ts"
export * from "./ExamLearn.vue?vue&type=script&lang=ts"

import "./ExamLearn.vue?vue&type=style&index=0&id=51090a25&lang=css"
script.render = render

export default script